import react from 'react';
import { message } from 'antd';
import { Fonts } from '../utils/constants';
import { apiURL } from '../utils/constants';
export function GetCanalDigital() : any {
    return new Promise((resolve, reject) => {
        fetch(apiURL +`/CanalArrendamiento`)
        .then(response => response.json())
                .then(result => {
                    resolve(result);
                })
        .catch(error => {
            reject(error)
            message.destroy();
            message.error({ content: 'Error al obtener el tipo de activo.', style: { fontFamily: Fonts.sspRegular } });
        })
    })
}


export function GetCanalDigitalID(id: number) : any {
    return new Promise((resolve, reject) => {
        fetch(apiURL + `/CanalArrendamiento?activoId=${id}`)
        .then(response => response.json())
                .then(result => {
                    resolve(result);
                })
        .catch(error => reject(error))
    })
}